import { AppId } from '@inno-tools/container-bridge'
import { FullPageAppTemplate } from 'modules/app-registry/templates'
import { useLocation, useNavigate } from 'react-router-dom'
import { useHistory, useUserContext } from 'shared/hooks'

import { useAvailableApps } from '../hooks/useAvailableApps'

export const BulkMailingApp = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const history = useHistory()
  const { user } = useUserContext()
  const { apps } = useAvailableApps()

  return (
    <FullPageAppTemplate
      appId={AppId.BULK_MAILING}
      scope='bulk_mailing'
      envKey={apps[AppId.BULK_MAILING].runtimeEnvKey}
      entryPath='./BulkMailingApp'
      url={process.env.REACT_APP_BULK_MAILING_APP_DEV_PATH}
      appName={apps[AppId.BULK_MAILING].name}
      appProps={{
        user,
        history: history,
        appPath: apps[AppId.BULK_MAILING].path,
        initialPath: location.pathname,
        onNavigate: ({ pathname: nextPathname }: { pathname: string }) => {
          const { pathname } = location
          if (pathname !== nextPathname) {
            navigate(nextPathname)
          }
        }
      }}
    />
  )
}
